import { render, staticRenderFns } from "./template-prize.vue?vue&type=template&id=0bd5b552&scoped=true&"
import script from "./template-prize.vue?vue&type=script&lang=js&"
export * from "./template-prize.vue?vue&type=script&lang=js&"
import style0 from "./template-prize.vue?vue&type=style&index=0&id=0bd5b552&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd5b552",
  null
  
)

export default component.exports